import { useMemo } from "react";
import { usePurchaseStates } from "../usePurchaseStates";
import { SubscriptionContractSubscriptionStatus } from "@smartrr/shared/shopifyGraphQL/api";

export const useNoActivePurchaseStates = () => {
  const purchaseStates = usePurchaseStates();
  return useMemo(
    () =>
      purchaseStates.every(
        purchaseState => purchaseState.purchaseStateStatus === SubscriptionContractSubscriptionStatus.Cancelled
      ),
    [purchaseStates]
  );
};
